module.exports = __webpack_public_path__ + "flyer_background_bicycle_059-60e69bf3a69696123f6889eba8eceab9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_bicycle_059.jpg
// module id = 1607
// module chunks = 1